module.exports = __webpack_public_path__ + "static/media/ideologiq_intro_mobile.67c7dd63.mp4";